/** Open work that belongs on the Ma “mai feladatok” list. No new columns. */

const OPEN_STATUSES = new Set(["planned", "in_progress", "blocked"]);

export type TodayTaskFields = {
  status: string;
  date_start_planned: string | null;
  date_end_planned: string | null;
  deleted_at?: string | null;
};

/**
 * In progress always counts as today.
 * Planned or blocked counts when the planned start/end overlaps `today`
 * (a single bound is that one day).
 */
export function isTaskForToday(task: TodayTaskFields, today: string): boolean {
  if (task.deleted_at) return false;
  if (!OPEN_STATUSES.has(task.status)) return false;
  if (task.status === "in_progress") return true;
  const start = task.date_start_planned;
  const end = task.date_end_planned;
  if (start && end) return start <= today && today <= end;
  if (start) return start === today;
  if (end) return end === today;
  return false;
}
